module.exports = __webpack_public_path__ + "static/media/Merkesdal.a71183b9.svg";